import React from "react";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { ProductDetailState } from "../../states/ProductDetailState";
import { Mapper } from "../../utils/Mapper";
import './ProductDetailPage.css';
import * as querystring from 'querystring';
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import Media from "react-media";
import Skeleton from "react-loading-skeleton";
import TrashIcon from "../../resources/wrappers/TrashIcon";
import _ from "lodash";
import { Route } from "react-router";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import { ImageViewer } from "../../components/image-viewer/ImageViewer";
import { ProductDto } from "../../models/ProductDto";
import { dataStore } from "../../services/storage/DataStore";

export class ProductDetailPage extends React.Component<any, ProductDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isError: false,
            isLoading: false,
            product: null,
            productId: undefined,
            productName: "",
            backgroundColor: "#9596AF",
            backgroundImage: "",
            hasImage: false,
            showDeleteDialog: false,
            showImage: false,
            showDeleteProductDialog: false,
            pageFrom: "",
            completePathPage: undefined
        }

        this.showOrHideDeletePopup = this.showOrHideDeletePopup.bind(this);
        this.showOrHideDeleteProductPopup = this.showOrHideDeleteProductPopup.bind(this);
    }

    componentDidMount() {
        if (this.props.match === undefined || this.props.match.params === undefined || this.props.match.params.id === undefined) {
            console.log("[ProductDetailPage] Error for missing id!");
            this.props.history.replace('/catalog');
        } else {
            let idFromParams = this.props.match.params.id;
            this.setState({ productId: idFromParams });
            let params = querystring.parse(this.props.location.search.replace("?", ''));
            if (!Mapper.checkProductMandatoryParams(params)) {
                console.log("[ProductDetailPage] Error for missing params!");
                this.props.history.replace('/catalog');
            } else {
                this.setState({ isLoading: true });
                GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Dettaglio prodotto', {});
                //@ts-ignore
                let productName = decodeURIComponent(params.name);
                let hasImage = params.hasImage;
                console.log("[ProductDetailPage] productName: " + productName + " hasImage: " + hasImage);
                //@ts-ignore
                this.setState({ productName: productName });
                const { state } = this.props.location
                if (hasImage) {
                    this.setState({ hasImage: true });
                    //@ts-ignore
                    let base64 = state.image;
                    let type = state.type;
                    if (base64 !== undefined) {
                        let dataUrl = "data:" + type + ";base64," + base64;
                        this.setState({ backgroundImage: dataUrl });
                    }
                }
                let pageFrom = state.pageFrom;
                this.setState({ pageFrom: pageFrom });
                let completePathPage = state.completePathPage;
                this.setState({ completePathPage: completePathPage });
                MposWebPortalApi.getInstance().getProduct(idFromParams).subscribe((response) => {
                    this.setState({ isLoading: false });
                    this.setState({ isError: false });
                    this.setState({ product: (response.product !== null && response.product !== undefined) ? response.product : null });
                }, error => {
                    this.setState({ isLoading: false });
                    this.setState({ isError: true });
                    this.setState({ product: null });
                })
            }
        }

        // Clear cache for addProduct
        dataStore.clearCategoryFromAddProduct();
        window.scrollTo(0, 0);
    }

    private getFormattedDate(input: string): string {
        console.log("[ProductDetailPage] getFormattedDate " + input)
        let temp = input.split(" ");
        let date = temp[0];
        let time = temp[1];
        let splittedDate = date.split("-");
        let splittedTime = time.split(":");

        return splittedDate[2] + "/" + splittedDate[1] + "/" + splittedDate[0] + " alle " + splittedTime[0] + ":" + splittedTime[1];
    }

    private showOrHideDeletePopup() {
        this.setState({ showDeleteDialog: !this.state.showDeleteDialog });
    }

    private showOrHideDeleteProductPopup() {
        this.setState({ showDeleteProductDialog: !this.state.showDeleteProductDialog });
    }

    private deleteProductImage() {
        let current = this.state.product;
        let updated = new ProductDto(current?.amount!, current?.categories!, current?.descr!, null, null, current?.name!,
            current?.productId!, null, current?.lastUpdate!);
        MposWebPortalApi.getInstance().updateProduct(updated).subscribe((response) => {
            this.showOrHideDeletePopup();
            this.setState({ backgroundColor: "#9596AF" });
            this.setState({ backgroundImage: "" });
            this.setState({ hasImage: false });
            this.setState({ product: updated });
        }, () => { });
    }

    private deleteProduct(history: any) {
        let urlToGo = (this.state.pageFrom !== "" && this.state.pageFrom === 'CatalogPage') ? "/catalog" : this.state.completePathPage;
        console.log('[ProductDetail] delete product url: ' + urlToGo);
        this.showOrHideDeleteProductPopup();
        if (this.state.pageFrom === 'CatalogPage') {
            window.history.pushState(null, '', '/');
            history.push('/catalog', { data: { operation: 'deleteProductFromDetail', toDelete: this.state.product } });
        } else {
            window.history.pushState(null, '', '/');
            history.push(urlToGo, { data: { operation: 'deleteProductFromDetail', toDelete: this.state.product } });
        }
    }

    private handleModifyProduct(history: any) {
        history.push('/addProduct/insertOrUpdate', { data: { product: this.state.product, update: true, pathToReturn: this.props.history.location.pathname + this.props.location.search } })
    }

    private handleChangeCategories(history: any) {
        history.push('/addProduct/categories', {
            data: {
                product: this.state.product, update: true, olds: JSON.stringify(this.state.product?.categories),
                pathToReturn: this.props.history.location.pathname + this.props.location.search
            }
        });
    }

    private showOrHideImage() {
        this.setState({ showImage: !this.state.showImage });
    }

    private getBase64Image(): string {
        let imageType = this.state.product?.imageType;
        if (imageType === undefined) {
            imageType = 'image/jpeg';
        }
        return "data:" + this.state.product?.imageType + ";base64," + this.state.product?.image;
    }


    render() {
        return this.state.isError ? <ServiceUnavailablePage /> : <div id={"main-container-product-details"}>
            <Media query="(max-width: 1064px)" render={() => {
                return (
                    <HeaderMobile showBack={true} showLogout={false} showTitle={false} hideBorder={true} background={this.state.backgroundColor} buttonContentColor={'#FFFFFF'}
                        backgroundImage={this.state.backgroundImage === "" ? undefined : this.state.backgroundImage} isSpecial>
                        <div className={"product-details-header-content"}>
                            <p className={"product-details-header-name"}>{this.state.productName}</p>
                        </div>
                    </HeaderMobile>);
            }} />
            <Media query="(min-width: 1065px)" render={() => {
                return (
                    <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={""} hideBorder={true} background={this.state.backgroundColor}
                        buttonContentColor={'#FFFFFF'} backgroundImage={this.state.backgroundImage === "" ? undefined : this.state.backgroundImage} isSpecial>
                        <div className={"product-details-header-content"}>
                            <p className={"product-details-header-name"}>{this.state.productName}</p>
                        </div>
                    </HeaderDesktop>);
            }} />
            <div className={"product-details-container-content"}>
                {
                    !this.state.isLoading && (this.state.product?.lastUpdate !== undefined && this.state.product?.lastUpdate !== null) &&
                    <p className={"product-details-update-info"}>Ultimo aggiornamento il {this.getFormattedDate(this.state.product.lastUpdate)}</p>
                }
                {[this.state.isLoading && <div className={"user-details-container-content-table-row"}>
                    <div className={"product-details-container-content-table-first-column"}>
                        <p className={"product-details-column-title"}>{"Informazioni prodotto".toUpperCase()}</p>
                        <Skeleton className={"product-details-container-table-first-column-skeleton"} />
                    </div>
                    <div className={"product-details-container-content-table-second-column"}>
                        <p className={"product-details-column-title"}>{"Categorie".toUpperCase()}</p>
                        <Skeleton className={"product-details-container-table-second-column-skeleton"} />
                    </div>
                </div>,
                !this.state.isLoading && <div className={"user-details-container-content-table-row"}>
                    <div className={"product-details-container-content-table-first-column"}>
                        <p className={"product-details-column-title"}>{"Informazioni prodotto".toUpperCase()}</p>
                        <div className={"product-details-first-column-box"}>
                            <div className={"product-details-name-field-container"}>
                                <p className={"product-details-label"}>Nome Prodotto</p>
                                <p className={"product-details-value"}>{this.state.product?.name?.charAt(0).toUpperCase()! + this.state.product?.name?.slice(1)!}</p>
                            </div>
                            <div className={"product-details-description-price-field-container"}>
                                <p className={"product-details-label"}>Descrizione (Opzionale)</p>
                                <p className={"product-details-value"}>{(this.state.product?.descr !== null && this.state.product?.descr !== undefined) ?
                                    this.state.product.descr === "" ? "-" : this.state.product.descr : "-"}</p>
                            </div>
                            <div className={"product-details-description-price-field-container"}>
                                <p className={"product-details-label"}>Prezzo (compreso IVA)</p>
                                <p className={"product-details-value"}>{(parseInt(this.state.product?.amount!!) / 100).toLocaleString('it-IT', {
                                    style: 'currency',
                                    currency: 'EUR',
                                })}</p>
                            </div>
                            <div className={(this.state.product?.image === null || this.state.product?.image === undefined || this.state.product?.image === "") ? "product-details-image-container" :
                                "product-details-image-container-bordered"}>
                                <p className={"product-details-label"}>Foto caricata</p>
                                {
                                    (this.state.product?.image === null || this.state.product?.image === undefined || this.state.product?.image === "") ?
                                        <p className={"product-details-value"}>-</p> :
                                        <div className={"product-details-image-detail-container"}>
                                            <p className={"product-details-image-link"} onClick={() => { this.showOrHideImage() }}>{this.state.product.imageName}</p>
                                            <div className={"product-details-trash-icon"} onClick={this.showOrHideDeletePopup}>
                                                <TrashIcon width={'25px'} height={'25px'} fill={'#F9423A'} />
                                            </div>
                                        </div>
                                }
                            </div>
                            <Route render={({ history }) => {
                                return <p className={"product-details-button"} onClick={() => this.handleModifyProduct(history)}>MODIFICA</p>
                            }} />
                        </div>
                    </div>
                    <div className={"product-details-container-content-table-second-column"}>
                        <p className={"product-details-column-title"}>{"Categorie".toUpperCase()}</p>
                        <div className={"product-details-second-column-box"}>
                            {_.map(this.state.product?.categories, (value) => {
                                return <div className={"product-details-badge-category-container"}>
                                    <div className={"product-details-oval-category"} style={{ backgroundColor: value.color! }} />
                                    <p className={"product-details-label-category"}>{value.name}</p>
                                </div>
                            })}
                            <Route render={({ history }) => {
                                return <p className={"product-details-button"} style={{ marginTop: '6px' }} onClick={() => this.handleChangeCategories(history)}>MODIFICA</p>
                            }} />
                        </div>
                    </div>
                </div>]}
                <div className={"product-details-row"}></div>
                <p className={"product-details-button-error"} onClick={() => this.showOrHideDeleteProductPopup()}>ELIMINA</p>
            </div>
            {this.state.showImage && <ImageViewer fullScreen={true} imageSrc={this.getBase64Image()} closeFunction={() => {
                { this.showOrHideImage() };
            }} />}
            <ConfirmDialog show={this.state.showDeleteDialog} onClose={this.showOrHideDeletePopup} title={"Elimina immagine prodotto"}
                content={"L’immagine del prodotto sarà eliminata anche da tutte le categorie in cui questo prodotto è inserito."}
                buttonNoText={"ANNULLA"} buttonYesText={"CONFERMA"} onConfirm={() => { this.deleteProductImage() }}
                customClassName={"product-details-confirm-dialog"} id={"product-detail-delete-image-dialog"} />

            {
                this.state.showDeleteProductDialog && <Route render={({ history }) => {
                    return <ConfirmDialog show={this.state.showDeleteProductDialog} onClose={this.showOrHideDeleteProductPopup} title={"Elimina prodotto"}
                        content={["Il prodotto non sarà più disponibile per nessuna categoria.", <br />, <br />, "Potrai reinserirlo cliccando “AGGIUNGI PRODOTTO” dalla pagina di una specifica categoria o direttamente dalla pagina “Il tuo catalogo”."]}
                        buttonNoText={"ANNULLA"} buttonYesText={"CONFERMA"} onConfirm={() => { this.deleteProduct(history) }}
                        customClassName={"product-details-confirm-dialog"} id={"product-detail-delete-image-dialog"} />
                }} />
            }
        </div>
    }
}